import { Chip } from '@mui/material';
import { cn } from 'cn';
import { type ReactNode } from 'react';

type P = {
  readonly activeLabel?: string;
  readonly chipClassName?: string;
  readonly disableSelectedValue?: boolean;
  readonly label: ReactNode;
  readonly onClick?: () => void;
  readonly onSelect: (value: string, data?: Record<string, unknown>) => void;
  readonly options: Array<{
    label: string;
    value: string;
    data: Record<string, unknown>;
  }>;
} & ComponentStyling;

export const ChipSelect = ({
  activeLabel,
  chipClassName,
  className,
  disableSelectedValue = true,
  label,
  onClick,
  onSelect,
  options,
  style,
}: P) => (
  <ul
    className={cn('dropdown-container group relative text-left', className)}
    style={style}
  >
    <Chip
      className={cn('relative z-30 w-fit select-none', chipClassName, {
        'cursor-pointer': Boolean(onClick),
      })}
      label={label}
      onMouseDown={onClick}
    />
    <div className="invisible absolute top-0 z-20 w-full overflow-hidden rounded-t-[16px] rounded-b-sm bg-white/60 pt-8.25 shadow backdrop-blur group-hover:visible">
      {options?.map((option) => (
        <li
          key={option.value}
          className={cn(
            'option-item w-full px-4 py-2 text-sm whitespace-nowrap select-none',
            option.value === activeLabel && disableSelectedValue
              ? 'cursor-not-allowed text-tiga-text-lightest'
              : 'cursor-pointer hover:bg-gray-200',
          )}
          onMouseDown={() => {
            if (option.value !== activeLabel || !disableSelectedValue) {
              onSelect(option.value, option.data);
            }
          }}
        >
          {option.label}
        </li>
      ))}
    </div>
  </ul>
);
